import { render, staticRenderFns } from "./footer.html?vue&type=template&id=0a22ff5e&scoped=true&"
import script from "./footer.js?vue&type=script&lang=js&"
export * from "./footer.js?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=0a22ff5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22ff5e",
  null
  
)

export default component.exports